import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Form } from "react-bootstrap";

// Use the environment variable for the API base URL
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const UserProfile = () => {
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState({
    location_name: "",
  });
  const [role, setRole] = useState(""); // State for user role
  const [organizations, setOrganizations] = useState([]);
  const [selectedOrganization, setSelectedOrganization] = useState({
    organization_name: "",
  });
  //const [profileImage, setProfileImage] = useState(null); // Profile image state
  const [previewImage, setPreviewImage] = useState(""); // Preview uploaded image

  // Fetch locations and organizations from the API
  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/locations`
        );
        const locationsWithId = response.data.locations.map((location) => ({
          ...location,
          id: location.location_code, // Assign location_code to id
        }));
        setLocations(locationsWithId);
      } catch (error) {
        console.error("Error fetching locations:", error);
        toast.error("Error fetching locations");
      }
    };

    const fetchOrganizations = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/organizations`
        );
        const organizationsWithId = response.data.organizations.map(
          (organization) => ({
            ...organization,
            id: organization.organization_code,
          })
        );
        setOrganizations(organizationsWithId);
      } catch (error) {
        console.error("Error fetching organizations:", error);
        toast.error("Error fetching organizations");
      }
    };

    fetchLocations();
    fetchOrganizations();
  }, []);

  // Handle user role change
  const handleUserTypeChange = (e) => {
    setRole(e.target.value);
  };

  // Handle profile image upload
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    //setProfileImage(file);
    const reader = new FileReader();
    reader.onload = () => {
      setPreviewImage(reader.result); // Set image preview
    };
    reader.readAsDataURL(file);
  };

  return (
    <div className="max-w-4xl mx-auto p-5">
      <div className="flex flex-wrap md:flex-nowrap bg-white shadow-lg rounded-lg">
        <div className="w-full md:w-1/3 p-4 border-r">
          <div className="flex flex-col items-center">
            {/* Profile Image */}
            <img
              className="w-24 h-24 rounded-full object-cover"
              src={previewImage || "https://via.placeholder.com/150"}
              alt="Profile"
            />
            <label
              htmlFor="upload-profile-image"
              className="mt-2 text-sm text-blue-600 cursor-pointer"
            >
              Upload Profile Image
            </label>
            <input
              id="upload-profile-image"
              type="file"
              accept="image/*"
              className="hidden"
              onChange={handleImageUpload}
            />
            <h2 className="mt-4 font-bold text-xl">Edogaru</h2>
            <p>edogaru@mail.com.my</p>
          </div>
        </div>
        <div className="w-full md:w-2/3 p-4">
          <h3 className="mb-3 font-semibold text-lg">Profile Settings</h3>
          <form>
            <div className="grid grid-cols-2 gap-4">
              <InputField label="UserName" placeholder="user name" />
              <InputField label="Email ID" placeholder="enter email id" />
              <InputField label="New Password" placeholder="new password" />
              <InputField
                label="Confirm Password"
                placeholder="enter confirm password"
              />
              <div className="mb-4 col-span-2">
                <label className="text-sm font-semibold block mb-2">
                  Location Name
                </label>
                <select
                  className="w-full px-4 py-2 text-sm border border-gray-300 rounded-lg"
                  value={selectedLocation.location_name}
                  onChange={(e) =>
                    setSelectedLocation({
                      ...selectedLocation,
                      location_name: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    Select Location
                  </option>
                  {locations.map((location) => (
                    <option key={location.id} value={location.location_name}>
                      {location.location_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-4 col-span-2">
                <label className="text-sm font-semibold block mb-2">
                  Organization Name
                </label>
                <select
                  className="w-full px-4 py-2 text-sm border border-gray-300 rounded-lg"
                  value={selectedOrganization.organization_name}
                  onChange={(e) =>
                    setSelectedOrganization({
                      ...selectedOrganization,
                      organization_name: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    Select Organization
                  </option>
                  {organizations.map((organization) => (
                    <option
                      key={organization.id}
                      value={organization.organization_name}
                    >
                      {organization.organization_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-4 col-span-2">
                <label className="text-sm font-semibold block mb-2">
                  User Role
                </label>
                <Form.Control
                  as="select"
                  name="role"
                  value={role}
                  onChange={handleUserTypeChange}
                  className="w-full px-4 py-2 text-sm border border-gray-300 rounded-lg"
                >
                  <option value="" disabled>
                    Select User Type
                  </option>
                  <option value="User">User</option>
                  <option value="Company Admin">Company Admin</option>
                  <option value="Main Admin">Main Admin</option>
                </Form.Control>
              </div>
            </div>
            <button
              type="submit"
              className="mt-4 bg-blue-500 hover:bg-blue-700 text-white py-2 px-4 rounded"
            >
              Save Profile
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

const InputField = ({ label, placeholder }) => (
  <div className="col-span-1">
    <label className="block mb-2 text-sm font-medium text-gray-900">
      {label}
    </label>
    <input
      type="text"
      placeholder={placeholder}
      className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
    />
  </div>
);

export default UserProfile;
